import React from 'react';
import instImage from './data/vova_inst.jpg';
import facebookImage from './data/vova_facebook.jpg';

export const Blog = () => {
  return (
    <div className="blog">
      <div className="blog-heading">
        <p>БЛОГ</p>
      </div>
      <div className="blog-content">
        <div className="blog-instagram blog-block">
          <img src={instImage} alt="Instagram" className="blog-image" />
          <div className="blog-instagram-button blog-button-block">
            <div className="blog-button">
              {/* <a href="#"> */}
                <i className="fab fa-instagram instagram-blog-button"></i>
              {/* </a> */}
            </div>
          </div>
        </div>
        <div className="blog-facebook blog-block">
          <img src={facebookImage} alt="Facebook" className="blog-image" />
          <div className="blog-instagram-button blog-button-block">
            <div className="blog-button blog-facebook-button">
              {/* <a href="#"> */}
                <i className="fab fa-facebook-square facebook-blog-button"></i>
              {/* </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
